import { PlannedInstallationComponent } from './use-planned-installation-devices'
import { Installation } from '../../models/installation.model'

type InstallationLocationAndOwner = Pick<Installation, 'ownerAccountId' | 'streetName' | 'streetNumber' | 'zip' | 'city' | 'countryCode'>

interface CompleteInstallationValidation {
  isValid: boolean
  validationStatus: {
    hasEmc: boolean
    hasStorage: boolean
    hasPowerMeter: boolean
    hasOwner: boolean
    hasLocation: boolean
    isSynced: boolean
  }
}

export const useCompleteInstallationValidation = (
  devices: PlannedInstallationComponent[],
  isEmcOnline: boolean,
  installation: InstallationLocationAndOwner | undefined,
  isSynced: boolean
): CompleteInstallationValidation => {
  const storages = devices.filter(device => device.deviceCategory === 'Storage')
  const powerMeter = devices.filter(device => device.deviceCategory === 'Meter')
  const hasRootPowerMeter = powerMeter.some(device => device.deviceType === 'InternalRoot' || device.deviceType === 'ExternalRoot')
  const hasCompleteLocation = [
    installation?.streetName,
    installation?.streetNumber,
    installation?.zip,
    installation?.city,
    installation?.countryCode,
  ].every(value => Boolean(value?.trim()))

  const validationStatus = {
    hasEmc: isEmcOnline,
    hasStorage: storages.length > 0 && storages.every(device => Boolean(device.serialNumber)),
    hasPowerMeter:
      powerMeter.length > 0 && hasRootPowerMeter && powerMeter.every(device => Boolean(device.serialNumber) && device.pairingState === 'paired'),
    hasOwner: Boolean(installation?.ownerAccountId),
    hasLocation: hasCompleteLocation,
    isSynced,
  }

  return {
    isValid: Object.values(validationStatus).every(Boolean),
    validationStatus,
  }
}
